import api from '@/core/api/client';

/** Provedores suportados hoje. Novos entram aqui sem refatorar os consumidores. */
export type GatewayProvider = 'STRIPE' | 'ASAAS';

export interface BillingSettingsData {
  id: number;
  manualEnabled?: boolean;
  asaasEnabled?: boolean;
  stripeEnabled?: boolean;

  // Mapeamento global por método → provedor.
  cardGateway: GatewayProvider;
  pixGateway: GatewayProvider;
  boletoGateway: GatewayProvider;

  // Asaas.
  asaasApiKey: string | null;
  asaasBaseUrl: string | null;

  // Stripe. Secrets retornam mascarados ('••••••••••') quando presentes;
  // publishableKey é pública e volta em claro.
  stripeApiKey: string | null;
  stripeWebhookSecret: string | null;
  stripePublishableKey: string | null;

  // NFS-e.
  nfEnabled: boolean;
  nfMunicipalServiceId: string | null;
  nfMunicipalServiceCode: string | null;
  nfIssRate: string;
  nfRetainIss: boolean;
  nfPis: string;
  nfCofins: string;
  nfCsll: string;
  nfInss: string;
  nfIr: string;
  updatedAt: string;
}

export const billingSettingsService = {
  async get(): Promise<BillingSettingsData> {
    const res = await api.get('/configuracoes/gateways');
    return res.data;
  },

  async update(data: Partial<BillingSettingsData>): Promise<BillingSettingsData> {
    const res = await api.patch('/configuracoes/gateways', data);
    return res.data;
  },
};
